'use client';

import { useShare } from '@/lib/useShare';

interface Props {
  titolo: string;
  descrizioneBreve?: string;
}

export default function ShareButton({ titolo, descrizioneBreve }: Props) {
  const { share, copied } = useShare(titolo, descrizioneBreve);

  return (
    <button
      onClick={share}
      className="mt-5 inline-flex items-center gap-2 font-section text-sm uppercase tracking-wide border border-chalk/40 text-chalk hover:bg-chalk/10 px-4 py-2 rounded-lg transition-colors"
      aria-label="Condividi questo evento"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-4 h-4 flex-shrink-0"
        aria-hidden="true"
      >
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
      </svg>
      {copied ? 'Link copiato!' : 'Condividi questo evento'}
    </button>
  );
}

